// 所有字段映射，仅保留 label 与 key
export const pureColumns = [
  { label: 'Project Type', key: 'projectType' },
  { label: 'CLC Door Code', key: 'doorCode' },
  { label: 'ClC Project Code', key: 'clcProjectCode' },
  { label: 'Pos Id Old', key: 'posIdOld' },
  { label: 'Pos Id New', key: 'posId' },
  { label: 'Franchise', key: 'franchise' },
  { label: 'Franchise Partner', key: 'franchisePartner' },
  { label: 'Status', key: 'status' },
  { label: 'Territory', key: 'territory' },
  { label: 'Previous Concept', key: 'previousConcept' },
  { label: 'Door Concept', key: 'doorConcept' },
  { label: 'Execution Flow', key: 'executionFlow' },
  { label: 'Execution Week Monday', key: 'executionWeekSunday' },
  { label: 'Execution Month', key: 'executionMonth' },
  { label: 'Execution Season', key: 'executionSeason' },
  { label: 'FY Quarter', key: 'fyQuarter' },
  { label: 'Store Callout(申诉)', key: 'storeAppeals' },
  { label: 'Store Callout Reason(申诉原因)', key: 'storeCalloutReason' },
  { label: 'City/Region (CN)', key: 'cityLocal' },
  { label: 'City/Region (EN)', key: 'city' },
  { label: 'Province/Region', key: 'province' },
  { label: 'Cluster Group', key: 'clusterGroup' },
  { label: 'Cluster Name', key: 'clusterName' },
  { label: 'Venue Name', key: 'venueName' },
  { label: 'District', key: 'district' },
  { label: 'Venue Code', key: 'venueCode' },
  { label: 'Road', key: 'road' },
  { label: 'Road No', key: 'roadNo' },
  { label: 'TZ ID', key: 'tzId' },
  { label: 'Trade Zone Name', key: 'tzName' },
  { label: 'Trade Zone Group', key: 'tzGroup' },
  { label: 'TTL Space (SQM)', key: 'ttlSpaceAftClc' },
  { label: 'FOH (SQM)', key: 'fohAftClc' },
  { label: 'BOH (SQM)', key: 'bohAftClc' },
  { label: 'TTL Space (SQFT)', key: 'ttlSpaceAftClcSqft' },
  { label: 'FOH (SQFT)', key: 'fohAftClcSqft' },
  { label: 'BOH (SQFT)', key: 'bohAftClcSqft' },
  { label: 'Store Environment', key: 'storeEnvironment' },
  { label: 'Landlord Group', key: 'landlordGroup' },
  { label: 'Landlord Name', key: 'landlordName' },
  { label: 'Account', key: 'account' },
  { label: 'Account Group', key: 'accountGroup' },
  { label: 'Name Local', key: 'storeNameLocal' },
  { label: 'Store Name English', key: 'storeName' },
  { label: 'Store Address', key: 'storeAddress' },
  { label: 'Rev FCST(¥)', key: 'revFcst' },
  { label: 'Rev FCST Comments', key: 'revComment' },
  { label: 'Area', key: 'area' },
  { label: 'Is Speed', key: 'speedUpFlag' },
  { label: 'SpeedUp Comment', key: 'speedUpComment' },
  { label: 'CLC Program', key: 'clcProgram' },
  { label: 'Fixture Type', key: 'fixtureType' },
  { label: 'First Round Planned Open Date', key: 'firstRoundPlannedOpenDate' },
  { label: 'Change Counter', key: 'changeCounter' },
  { label: 'Longitude', key: 'longitude' },
  { label: 'Latitude', key: 'latitude' },
  { label: 'Landlord Contact', key: 'landlordContact' },
  { label: 'Landlord Telephone', key: 'landlordTelephone' },
  { label: 'Floor', key: 'floor' },
  { label: 'Support Rate', key: 'supportRate' },
  { label: 'Format', key: 'format' },
  { label: 'First CLC Date For MI', key: 'firstClcDateForMi' },
  { label: 'Reference Sold To', key: 'referenceSoldTo' },
  { label: 'Reference Ship To', key: 'referenceShipTo' },
  { label: 'Account Owner', key: 'accountOwner' },
  { label: 'Mapping Owner', key: 'mappingOwner' },
  { label: 'RE Owner', key: 'reOwner' },
  { label: 'PGM Owner', key: 'pgmOwner' },
  { label: 'SD Owner', key: 'sdOwner' },
  { label: 'Design Owner', key: 'designOwner' },
  { label: 'Contact Person', key: 'contactPerson' },
  { label: 'Store Contact Number', key: 'storeContactNumber' },
  { label: 'Opening Hours', key: 'openingHours' },
  { label: 'Hub Flag', key: 'hubFlag' },
  { label: 'Facade Flag', key: 'facadeFlag' },
  { label: 'Is Duplicate', key: 'isDuplicate' },
  { label: 'Is Duplicate', key: 'duplicateStatus' },
  { label: 'Duplicate Code', key: 'duplicateCode' },
  { label: 'Store Image', key: 'storeImage' },
  { label: 'City Tier Official', key: 'cityTier' },
  { label: 'Venue Grade', key: 'venueGrade' },
  { label: 'Landlord Tier', key: 'landlordTier' },
  { label: 'Landlord Type', key: 'landlordType' },
  { label: 'Project Sub Type', key: 'subProjectType' },
  { label: 'Store Code', key: 'storeCode' },
  { label: 'Closure Date', key: 'closureDate' },
  { label: 'Closure Reason', key: 'closureReason' },
  { label: 'AE Comment', key: 'aeComment' },
  { label: 'TNS Tiering', key: 'tnsTiering' },
  { label: 'Project Tag', key: 'projectTag' },
]

export interface DetailField {
  key: string
  type?: 'input' | 'textarea'
  fullRow?: boolean
  nodes?: string[]
}

export const detailFieldGroups: Record<
  'BasicInformation' | 'Location' | 'Landlord' | 'Space',
  DetailField[]
> = {
  BasicInformation: [
    { key: 'duplicateStatus', nodes: ['N4', 'N5'] },
    { key: 'duplicateCode', nodes: ['N4', 'N5'] },
    { key: 'storeNameLocal', type: 'textarea', fullRow: true },
    { key: 'clcProjectCode', fullRow: true },
    { key: 'posIdOld' },
    { key: 'posId' },
    { key: 'previousConcept' },
    { key: 'doorConcept' },
    { key: 'projectType' },
    { key: 'subProjectType' },
    { key: 'executionFlow' },
    { key: 'fyQuarter' },
    { key: 'account' },
    { key: 'accountGroup' },
    { key: 'status' },
    { key: 'storeEnvironment' },
    { key: 'revFcst' },
    { key: 'format' },
    { key: 'hubFlag' },
    { key: 'tnsTiering' },
    { key: 'projectTag' },
  ],
  Location: [
    { key: 'clusterName' },
    { key: 'province' },
    { key: 'cityLocal' },
    { key: 'cityTier' },
    { key: 'tzName' },
    { key: 'tzGroup' },
    { key: 'floor' },
    { key: 'storeAddress', type: 'textarea', fullRow: true },
    { key: 'venueName', type: 'textarea', fullRow: true },
    { key: 'venueCode' },
    { key: 'venueGrade' },
  ],
  Landlord: [
    { key: 'landlordName' },
    { key: 'landlordGroup' },
    { key: 'landlordTier' },
    { key: 'landlordType' },
  ],
  Space: [
    { key: 'ttlSpaceAftClc' },
    { key: 'ttlSpaceAftClcSqft' },
    { key: 'fohAftClc' },
    { key: 'fohAftClcSqft' },
    { key: 'bohAftClc' },
    { key: 'bohAftClcSqft' },
    { key: 'fixtureType' },
    { key: 'pgmOwner' },
  ],
}

export interface EditConfigItem {
  key: string
  required: boolean
  type: 'select' | 'radio' | 'input' | 'textarea'
  /** When set, the row is shown only if `editForm[visibleWhen.key]` equals `visibleWhen.equals`. */
  visibleWhen?: { key: string; equals: string }
}

export const detailEditConfig: Record<string, EditConfigItem[]> = {
  'K2.1': [
    { key: 'hubFlag', required: true, type: 'select' },
    { key: 'facadeFlag', required: true, type: 'select' },
  ],
  'K2.2': [{ key: 'account', required: true, type: 'select' }],
  K3: [
    { key: 'franchise', required: true, type: 'select' },
    {
      key: 'franchisePartner',
      required: false,
      type: 'input',
      visibleWhen: { key: 'franchise', equals: 'Franchise' },
    },
  ],
  'K4.1': [
    { key: 'ttlSpaceAftClc', required: false, type: 'input' },
    { key: 'ttlSpaceAftClcSqft', required: false, type: 'input' },
    { key: 'fohAftClc', required: false, type: 'input' },
    { key: 'fohAftClcSqft', required: false, type: 'input' },
    { key: 'storeImage', required: false, type: 'select' },
    { key: 'fixtureType', required: false, type: 'select' },
    { key: 'pgmOwner', required: false, type: 'select' },
  ],
  K10: [
    { key: 'ttlSpaceAftClc', required: false, type: 'input' },
    { key: 'ttlSpaceAftClcSqft', required: false, type: 'input' },
    { key: 'fohAftClc', required: false, type: 'input' },
    { key: 'fohAftClcSqft', required: false, type: 'input' },
    { key: 'storeImage', required: false, type: 'select' },
    { key: 'fixtureType', required: false, type: 'select' },
    { key: 'pgmOwner', required: false, type: 'select' },
    { key: 'speedUpFlag', required: false, type: 'radio' },
    { key: 'speedUpComment', required: false, type: 'input' },
  ],
  N2: [
    { key: 'hubFlag', required: true, type: 'select' },
    { key: 'facadeFlag', required: true, type: 'select' },
    { key: 'isDuplicate', required: false, type: 'radio' },
    { key: 'duplicateCode', required: false, type: 'input' },
  ],
  N3: [
    { key: 'isDuplicate', required: true, type: 'radio' },
    { key: 'duplicateCode', required: false, type: 'input' },
  ],
  N5: [{ key: 'account', required: true, type: 'select' }],
  J9: [{ key: 'storeImage', required: true, type: 'select' }],
  N6: [
    { key: 'franchise', required: true, type: 'select' },
    {
      key: 'franchisePartner',
      required: false,
      type: 'input',
      visibleWhen: { key: 'franchise', equals: 'Franchise' },
    },
    { key: 'ttlSpaceAftClc', required: false, type: 'input' },
    { key: 'ttlSpaceAftClcSqft', required: false, type: 'input' },
    { key: 'fohAftClc', required: false, type: 'input' },
    { key: 'fohAftClcSqft', required: false, type: 'input' },
    { key: 'storeImage', required: false, type: 'select' },
    { key: 'fixtureType', required: false, type: 'select' },
    { key: 'pgmOwner', required: false, type: 'select' },
  ],
  N8: [
    { key: 'ttlSpaceAftClc', required: false, type: 'input' },
    { key: 'ttlSpaceAftClcSqft', required: false, type: 'input' },
    { key: 'fohAftClc', required: false, type: 'input' },
    { key: 'fohAftClcSqft', required: false, type: 'input' },
    { key: 'storeImage', required: false, type: 'select' },
    { key: 'fixtureType', required: false, type: 'select' },
    { key: 'pgmOwner', required: false, type: 'select' },
  ],
  'N10.2': [
    { key: 'previousConcept', required: false, type: 'select' },
    { key: 'doorConcept', required: false, type: 'select' },
  ],
  'N10.3': [
    { key: 'previousConcept', required: false, type: 'select' },
    { key: 'doorConcept', required: false, type: 'select' },
    { key: 'ttlSpaceAftClc', required: false, type: 'input' },
    { key: 'ttlSpaceAftClcSqft', required: false, type: 'input' },
    { key: 'fohAftClc', required: false, type: 'input' },
    { key: 'fohAftClcSqft', required: false, type: 'input' },
    { key: 'storeImage', required: false, type: 'select' },
    { key: 'fixtureType', required: false, type: 'select' },
    { key: 'pgmOwner', required: false, type: 'select' },
    { key: 'speedUpFlag', required: false, type: 'radio' },
  ],
  'N10.4': [
    { key: 'ttlSpaceAftClc', required: false, type: 'input' },
    { key: 'ttlSpaceAftClcSqft', required: false, type: 'input' },
    { key: 'fohAftClc', required: false, type: 'input' },
    { key: 'fohAftClcSqft', required: false, type: 'input' },
    { key: 'storeImage', required: false, type: 'select' },
    { key: 'fixtureType', required: false, type: 'select' },
    { key: 'speedUpFlag', required: false, type: 'radio' },
    { key: 'speedUpComment', required: false, type: 'input' },
  ],
}

// 编辑框下拉选项映射
export const detailSelectOptions: Record<string, string[]> = {
  hubFlag: ['City Hub', 'Cluster Hub', 'National Hub', 'SPOKE', 'Trade Zone Hub'],
  facadeFlag: ['Billboard', 'Must to have', 'Nice to have'],
  storeImage: ['Existing', 'Lifestyle', 'WOF'],
  franchise: ['Franchise', 'Own'],
}
